// Client.js
import React from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import './Client.css';
import Clientlogo from "./Client-details";

const Client = () => {
    var settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        autoplay:true,
        slidesToScroll:1,
        
    responsive: [
        {
            breakpoint: 992,
            settings: {
              arrows: false,
              slidesToShow: 3,
            },
          },
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          arrows: false,
          slidesToShow: 1,
        },
      },
    ],
      };

    return (
        <div className="client-logo">
            <div className="container">
              <h5>Happy Customers</h5>
            <Slider {...settings}>
            {Clientlogo.map((client) => (
                
                    
                        <div key={client.id}>
                            <img src={process.env.PUBLIC_URL + client.images} alt={`logo${client.id}`} />
                        </div>
                   
            
                 ))}
                 </Slider>
            </div>
            
        </div>
    );
}

export default Client;
